import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { IPost } from "../../../../types/models/post.models.types";
import { useGetHttp } from "../../http.hook";

export interface IPostResponse {
  posts: Array<IPost>;
  pagination: IPagination;
}

export function useGetPostsEmphemeralHttp() {
  return useGetHttp<IPostResponse>({
    path: "/ephemeral/brand-dash/posts",
  });
}
